export default {
  'puppyclub:puppy-phase:A': 'De Pets Deli Pootjesclub - meld je nu gratis aan!',
  'puppyclub:puppy-phase:B': 'Over mijn puppy',
  'puppyclub:puppy-phase:C': 'Over mij',

  'puppyclub:register': 'GRATIS AANMELDEN',

  'puppyclub:puppy-phase:thank-you':
    'Bedankt voor je aanmelding en welkom bij de Pets Deli Pootjesclub!',
  'puppyclub:puppy-phase:thank-you-email-confirmation':
    'We sturen je een bevestiging per e-mail - kijk het beste meteen even in je inbox!',
  'puppyclub:puppy-phase:thank-you-subtitle':
    'In de komende weken kun je geweldige exclusieve aanbiedingen verwachten, veel nuttige informatie over je puppy en natuurlijk heel veel pootjescontent. Veel plezier!',
};
